import { Tabs } from "antd";
import "./index.scss";

export function TabsMenu({ tabs, onChange, defaultActiveKey, activeKey, ...rest }) {
  const handleChange = (activeKey) => {
    onChange && onChange(activeKey);
  };

  return (
    <Tabs
      className="custom-tabs"
      activeKey={activeKey}
      defaultActiveKey={defaultActiveKey}
      onChange={handleChange}
      {...rest}
    >
      {tabs?.map((tab) => (
        <Tabs.TabPane tab={<span className="title">{tab.title}</span>} key={tab.key}>
          {tab.children}
        </Tabs.TabPane>
      ))}
    </Tabs>
  );
}

export default TabsMenu;
